import { IMenuSettings } from './types';

const parseWorkflowVisibility = (menuSettings: IMenuSettings, workflowTemplateUI: string) => {
    return !!menuSettings?.WorkflowsEnabled?.find(
        (item) => item.WorkflowTemplateUI === workflowTemplateUI && item.Active
    );
};

export default parseWorkflowVisibility;
